import { getExpressionData } from "api/expression";
import { getTagData } from "api/tags";

const unityColumnConfig = {
  getTagData,
  getExpressionData
};

export default unityColumnConfig;